const firebaseConfig = {
  apiKey: "AIzaSyBry1YYrCMYURkZVDoyxOu2kZw-eC7LaaE",
  authDomain: "happy-mom-1027a.firebaseapp.com",
  projectId: "happy-mom-1027a",
  storageBucket: "happy-mom-1027a.appspot.com",
  messagingSenderId: "929089570357",
  appId: "1:929089570357:web:9ce526669bb7dcaa6fd37c",
};
export default firebaseConfig;
